import block from "./block.js";
import component from "./component.js"

export default (editor, opts = {}) => {
  editor.DomComponents.addType("slideShowCard3", component(opts));
  editor.BlockManager.add("slideShowCard3", block(opts));
};